import { IUserGroup } from '@boldpenguin/sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const userGroupsStateKey = 'userGroups';

export default interface IUserGroupsState {
  groupsLoaded: boolean;
  loadingGroupsError: string;
  groups: EntityState<IUserGroup>;
}

export const groupsAdapter: EntityAdapter<IUserGroup> =
  createEntityAdapter<IUserGroup>();

export const userGroupsInitialState: IUserGroupsState = {
  groupsLoaded: false,
  loadingGroupsError: '',
  groups: groupsAdapter.getInitialState(),
};
